export default __webpack_public_path__ + "c0d2e3e89dbe6311bb33d29593303111.svg";